"use client";

import type { LiteralUnion } from "@frend-digital/utils";
import { createContext, useContext, type ComponentProps } from "react";
import type { FlagKeys } from "./flags";

export const FlagsContext = createContext<{ flags: Record<string, boolean> }>(null!);

export const FlagsProvider = (props: ComponentProps<typeof FlagsContext.Provider>) => {
	return <FlagsContext.Provider {...props} />;
};

export const useFlag = (key: LiteralUnion<FlagKeys, string>) => {
	const ctx = useContext(FlagsContext);

	return ctx.flags[key] ?? false;
};
